import Backend from 'i18next-http-backend/cjs'
import path from 'path'
import { inspect } from 'util'
inspect.defaultOptions = { depth: 20 }

const cdnEndpoint = `${process.env.NEXT_PUBLIC_I18N_CDN_HOST}/${process.env.NEXT_PUBLIC_I18N_CDN_PREFIX}`
const loadPathWithNamespaces = `${cdnEndpoint}/{{ns}}/{{lng}}.json`

/** @type import("next").I18NConfig */
const i18n = {
  defaultLocale: 'fr',
  locales: ['fr', 'en', 'es', 'nl'],
  localeDetection: false, // disable automatic redirection on the user's preferred locale
  domains: [
    {
      domain: 'milesrepublic.com',
      defaultLocale: 'en-us'
    },
    {
      domain: 'fr.milesrepublic.com',
      defaultLocale: 'fr'
    },
    {
      domain: 'be.milesrepublic.com',
      defaultLocale: 'fr-be',
      locales: ['nl-be']
    },
    {
      domain: 'nl.milesrepublic.com',
      defaultLocale: 'nl-nl'
    }
  ]
}

/** @type import("next-i18next").UserConfig */
const next18nextConfig = {
  i18n,
  localePath: null,
  reloadOnPrerender: true,
  serializeConfig: false,
  // adding "fr" to the fallback languages to keep the same behavior as before. The "en" language will be added too now
  // We will be able to remove "fr" once we change the [typeOrDistance] behavior
  fallbackLng: ['en', 'fr'],
  defaultNS: 'common',
  backend: {
    loadPath: loadPathWithNamespaces,
    customHeaders:
      process.env.VERCEL_ENV === 'production'
        ? {}
        : { 'aws-cf-cd-staging': '1' }
  },
  use: [Backend]
}

export default next18nextConfig
